import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { first, map } from 'rxjs/operators'
import { UserServiceApiService } from './user-service-api.service'

export interface CsrfToken {
  csrf_token: string
}

@Injectable({
  providedIn: 'root'
})
export class UserServiceCsrfTokenService  {
  constructor(
    private api: UserServiceApiService,
  ) { }

  public fetchCsrfToken(): Observable<CsrfToken> {
    const url = 'csrf_token'

    return this.api.get<CsrfToken>(url).pipe(
      first(),
      map(r => r?.result)
    )
  }
}
